<template>
  <el-input
    class="i-wrp"
    :id="id"
    :label="label"
    :type="getType"
    :value="value"
    :placeholder="placeholder"
    suffix-icon="el-icon-view"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @click.native="onClick($event.target)"
  ></el-input>
</template>

<script>
  export default {
    data: () => ({
      isShown: false,
    }),
    props: {
      value: {
        type: String,
        required: true,
      },
      label: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      id: {
        type: String,
      },
    },
    computed: {
      getType() {
        return this.isShown ? 'text' : 'password';
      },
    },
    methods: {
      onClick(element) {
        if (element.closest('.el-icon-view')) {
          this.isShown = !this.isShown;
        }
      },
    },
  };
</script>

<style lang="scss">
  .i-wrp {
    .el-input__suffix {
      cursor: pointer;
    }
  }
</style>
